import Vietnamese from '@/locales/vi-VN';
// import vi from '@/locales/vi-VN';

export const formatMessage = ({ id, defaultText } : {id: keyof typeof Vietnamese, defaultText?: string}) : string => {
    return Vietnamese[id] || (defaultText || '');
}
